import { render, staticRenderFns } from "./quiz-results.html?vue&type=template&id=075750f2&scoped=true&"
import script from "./quiz-results.vue?vue&type=script&lang=js&"
export * from "./quiz-results.vue?vue&type=script&lang=js&"
import style0 from "./quiz-results.css?vue&type=style&index=0&id=075750f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075750f2",
  null
  
)

export default component.exports